/// <amd-module name="VSS/Redux/Modules/VSSPageData/VSSPageDataContracts" />
import { IPageData } from "VSS/Platform/Page";

export interface IVSSPageDataAwareState {
    vssPageData: IPageData | null;
}
